import React from 'react'
import { SvgIconProps } from './Home'

const SvgCustomizeIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "18"}
    height={height ?? "19"}
    fill="none"
    viewBox="0 0 18 19"
  >
    <path
      fill={fill ?? "#353535"}
      d="M17.1 5.366c-.45 0-.9.356-.9.949v8.3c0 .118-.113.236-.225.236H1.912c-.112 0-.224-.118-.224-.237V5.13c0-.119.112-.237.225-.237H9.45c.45 0 .9-.356.9-.949s-.338-.83-.787-.83h-7.65C.9 3.113 0 4.062 0 5.13v9.485c0 1.067.9 2.016 1.913 2.016H8.1v.593H5.963c-.45 0-.9.355-.9.948s.45.83.9.83h5.962c.45 0 .9-.356.9-.949 0-.592-.337-.948-.9-.948H9.788v-.474h6.187c1.013 0 1.912-.949 1.912-2.016v-8.3c.113-.592-.337-.948-.787-.948z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M4.725 10.7c-.112.475-.225.949-.337.949h-.563c-.45 0-.9.356-.9.949 0 .474.338.948.9.948h2.7c1.688 0 3.038-.474 3.825-1.423.563-.711.788-1.422.788-2.015l6.187-6.64c.45-.356.675-.83.675-1.423 0-.593-.225-1.067-.562-1.423-.788-.83-2.025-.83-2.7 0L8.325 7.144c-2.7.237-3.262 2.37-3.6 3.556zM9.9 8.092l5.963-6.165c.112-.119.225-.119.337 0l.113.118s0 .119-.113.119l-5.85 6.284-.45-.356zm-3.6 3.557c0-.119.113-.356.113-.474v-.119c.337-1.185.562-2.015 1.912-2.134l1.125 1.186c0 .237-.112.474-.337.83-.45.474-1.35.711-2.588.711H6.3z"
    ></path>
  </svg>
)

export default SvgCustomizeIcon